import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

class GoogleTracking {

  analytics;

  constructor() {
    this.analytics = Analytics({
      app: 'awesome-app',
      plugins: [
        googleAnalytics({
          measurementIds: [process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID]
        })
      ]
    })
  }

  trackPurchase(product, priceId, quantity, value) {
    this.analytics.track('conversion_event_purchase_1', {
      item: product,
      price: value * quantity
    });
  }

  trackInitiateCheckout(product, priceId, quantity, value) {
    this.analytics.track('conversion_event_begin_checkout_1', {
      item: product,  
      price: value * quantity
    });
  }

  trackAddPaymentInfo(product, priceId, quantity, value) {
    this.analytics.track('add_payment_info', {
      value: value * quantity,
      items: [{
        item_id: priceId,
        item_name: product,
        quantity: quantity,
        price: value
      }],
      currency: 'USD'
    });
  }

  trackCustom(event, data) {
    this.analytics.track(event, data);
  }
}

export default GoogleTracking;
